export default [
  {
    location_code: "L001",
    timezone: "America/New_York"
  },
  {
    location_code: "L002",
    timezone: "America/Chicago"
  },
  {
    location_code: "L003",
    timezone: "America/New_York"
  },
  {
    location_code: "L004",
    timezone: "America/Chicago"
  },
  {
    location_code: "L005",
    timezone: "America/Chicago"
  },
  {
    location_code: "L006",
    timezone: "America/New_York"
  },
  {
    location_code: "L007",
    timezone: "America/New_York"
  },
  {
    location_code: "L008",
    timezone: "America/New_York"
  },
  {
    location_code: "L009",
    timezone: "America/New_York"
  },
  {
    location_code: "L010",
    timezone: "America/New_York"
  },
  {
    location_code: "L011",
    timezone: "America/New_York"
  },
  {
    location_code: "L012",
    timezone: "America/New_York"
  },
  {
    location_code: "L013",
    timezone: "America/Chicago"
  },
  {
    location_code: "L014",
    timezone: "America/Chicago"
  },
  {
    location_code: "L015",
    timezone: "America/Chicago"
  },
  {
    location_code: "L016",
    timezone: "America/New_York"
  },
  {
    location_code: "L017",
    timezone: "America/New_York"
  },
  {
    location_code: "LTRAIN",
    timezone: "America/Los_Angeles"
  }
];
